import { Form } from "devextreme-react";
import {
  AsyncRule,
  EmailRule,
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import ContactPersonComponent from "./ContactPersonComponent";
import { useEffect, useState } from "react";
import axios from "axios";
import DataSource from "devextreme/data/data_source";
import { useDispatch } from "react-redux";
import {
  updateEmail,
  updateMob,
  updateMobile,
  updateRole,
  updateTel,
} from "./Redux/sponsorInfo";
import styled from "styled-components";
import RoleComponent from "./RoleComponent";

const SponsorInfoFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function SponsorInfoForm(props) {
  const { sponsorInfo, formSponsorInfoRef, sales } = props;

  const dispatch = useDispatch();

  // const [roleDataSource, setRoleDataSource] = useState(null);

  // useEffect(async () => {
  //   const result = await axios.get(
  //     `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/sprInfo/role`
  //   );

  //   setRoleDataSource(
  //     new DataSource({
  //       store: {
  //         data: result.data,
  //         type: "array",
  //         key: "role",
  //       },
  //     })
  //   );
  // }, []);

  const onEmailValueChanged = (e) => {
    dispatch(
      updateEmail({
        email: e.value,
      })
    );
  };

  // const onRoleValueChanged = (e) => {
  //   dispatch(
  //     updateRole({
  //       role: e.value,
  //     })
  //   );
  // };

  const onTelValueChanged = (e) => {
    dispatch(
      updateTel({
        tel: e.value ? e.value.trim() : null,
      })
    );
  };

  const onMobValueChanged = (e) => {
    dispatch(
      updateMob({
        mob: e.value ? e.value.trim() : null,
      })
    );
  };

  // const onCustomItemCreating = (args) => {
  //   if (!args.text) {
  //     args.customItem = null;

  //     return;
  //   }

  //   const newItem = {
  //     role: args.text,
  //   };

  //   args.customItem = roleDataSource
  //     .store()
  //     .insert(newItem)
  //     .then(() => roleDataSource.load())
  //     .then(() => newItem)
  //     .catch((error) => {
  //       throw error;
  //     });
  // };

  const validationCallback = async ({ value }) => {
    if (sponsorInfo.email) {
      if (sponsorInfo.action == "insert") {
        const result = await axios.get(
          `${
            process.env.REACT_APP_BECCO_API_URL
          }/api/salesMgmt/sales/info/sprInfo/chkEmail/${sales.contrNo.substring(
            4,
            7
          )}/${value}`
        );

        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(result.data.count == 0);
          }, 1000);
        });
      } else {
        return true;
      }
    }
  };

  return (
    <SponsorInfoFormWrapper>
      <Form
        id="form-sponsorInfo"
        ref={formSponsorInfoRef}
        // colCount={4}
        colCount={3}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="sponsorInfoData"
      >
        <SimpleItem
          dataField={"email"}
          editorType={"dxTextBox"}
          // colSpan={2}
          editorOptions={{
            value: sponsorInfo.email,
            readOnly: sponsorInfo.action == "insert" ? false : true,
            onValueChanged: onEmailValueChanged,
          }}
        >
          <Label text={"Email"} />
          <RequiredRule message={"Email is required."} />
          <EmailRule message={"Email is invalid."} />
          {/* {sponsorInfo.action == "insert" && (
            <AsyncRule
              message={"Email already exists."}
              validationCallback={validationCallback}
            />
          )} */}
        </SimpleItem>
        <SimpleItem
          dataField={"contactPerson"}
          // colSpan={2}
        >
          <Label text={"Contact Person"} />
          <ContactPersonComponent sponsorInfo={sponsorInfo} />
          <RequiredRule
            message={"Name and position of contact person are required."}
          />
        </SimpleItem>
        {/* <SimpleItem
          dataField={"role"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: roleDataSource,
            displayExpr: "role",
            valueExpr: "role",
            acceptCustomValue: true,
            value: sponsorInfo.role,
            showClearButton: true,
            onValueChanged: onRoleValueChanged,
            onCustomItemCreating: onCustomItemCreating,
          }}
        >
          <Label text={"Role"} />
          <RequiredRule message={"Role is required."} />
        </SimpleItem> */}
        <SimpleItem dataField={"role"}>
          <Label text={"Role"} />
          <RoleComponent sponsorInfo={sponsorInfo} />
          <RequiredRule message={"Role is required"} />
        </SimpleItem>
        <SimpleItem
          dataField={"tel"}
          editorType={"dxTextBox"}
          editorOptions={{
            showClearButton: true,
            value: sponsorInfo.tel,
            placeholder: "+82-00-0000-0000",
            onValueChanged: onTelValueChanged,
          }}
        >
          <Label text={"Telephone"} />
          <RequiredRule message={"Telephone number is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"mob"}
          editorType={"dxTextBox"}
          editorOptions={{
            showClearButton: true,
            //   mask: sponsorInfo.action == "insert" ? "\\+82-1\\0-0000-0000" : null,
            value: sponsorInfo.mob,
            placeholder: "+82-10-0000-0000",
            onValueChanged: onMobValueChanged,
          }}
        >
          <Label text={"Mobile"} />
          <RequiredRule message={"Mobile number is required."} />
        </SimpleItem>
        <EmptyItem />
      </Form>
    </SponsorInfoFormWrapper>
  );
}
